module.exports = __webpack_public_path__ + "img/20.76e55abf.jpg";